// Student Editor - PartBPage8 (editable reflection prompts)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useActivityContext } from '../index';
import { API_CONFIG } from '../../../../../config/api';

const PartBPage8 = () => {
  const { activity } = useActivityContext();
  const [formData, setFormData] = useState({
    what_i_learned: '',
    most_enjoyable_part: '',
    three_strengths: '',
    challenges_faced: '',
    two_areas_improvement: '',
    questions_still_have: '',
    teacher_modifications: ''
  });
  const [saveMessage, setSaveMessage] = useState('');

  useEffect(() => {
    // Backend returns page_8 as the learner_reflection object directly (line 1488 in backend)
    if (activity?.my_response?.page_8) {
      setFormData(activity.my_response.page_8);
    }
  }, [activity]);

  const handleChange = (field, value) => {
    const newData = { ...formData, [field]: value };
    setFormData(newData);
    saveChanges(newData);
  };

  const saveChanges = async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = API_CONFIG.BASE_URL;
      await axios.put(`${apiUrl}/secondary/user/domain-activities/${activity.activity_id}/part-b/page/8/student-fields`, data, { headers: { Authorization: `Bearer ${token}` } });
      setSaveMessage('Saved ✓');
      setTimeout(() => setSaveMessage(''), 2000);
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('Error');
    }
  };

  const teacherComments = activity?.part_b?.page_8?.teacher_comments || {};

  const reflectionPrompts = [
    { key: 'what_i_learned', label: 'What did I learn from this project?' },
    { key: 'most_enjoyable_part', label: 'What was the most enjoyable part of the project?' },
    { key: 'three_strengths', label: 'Three strengths I demonstrated in this project' },
    { key: 'challenges_faced', label: 'What were the challenges I faced doing the project?' },
    { key: 'two_areas_improvement', label: 'Two areas of improvement I identified in this project' },
    { key: 'questions_still_have', label: 'Some questions I still have...' },
    { key: 'teacher_modifications', label: 'How could your teacher modify this project to make it more interesting?' }
  ];

  return (
    <div style={{
      width: '100%',
      maxWidth: '1400px',
      minHeight: '80vh',
      margin: '0 auto',
      padding: '40px', backgroundColor: 'white', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', position: 'relative', fontFamily: "'Poppins', Arial, sans-serif"
    }}>
      {saveMessage && <div style={{ position: 'fixed', top: '20px', right: '20px', backgroundColor: '#4caf50', color: 'white', padding: '8px 16px', borderRadius: '4px', zIndex: 1000 }}>{saveMessage}</div>}

      {/* Decorative Corners */}


      {/* Header */}
      <div style={{ backgroundColor: '#F4824C', color: 'white', fontSize: '14px', fontWeight: 'bold', padding: '10px', textAlign: 'center', marginBottom: '16px' }}>
        Post-project reflections
      </div>

      {/* Teacher Comments - View Only */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '6px' }}>
          Final comments by the teacher (if any):
        </div>
        <div style={{ backgroundColor: '#FFE5D5', padding: '10px', minHeight: '50px', fontSize: '14px', borderRadius: '4px', marginBottom: '8px', color: '#666' }}>
          {teacherComments.most_important_contribution || "The learner's most important contribution to the project was..."}
        </div>
        <div style={{ backgroundColor: '#FFE5D5', padding: '10px', minHeight: '50px', fontSize: '14px', borderRadius: '4px', color: '#666' }}>
          {teacherComments.areas_for_improvement || 'To perform better in future projects, the learner should work on...'}
        </div>
      </div>

      {/* Learner Reflection - Editable */}
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <svg width="40" height="60" viewBox="0 0 40 60">
            <circle cx="20" cy="15" r="10" fill="#333" stroke="#000" strokeWidth="2" />
            <line x1="20" y1="25" x2="20" y2="45" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="30" x2="12" y2="40" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="30" x2="28" y2="40" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="45" x2="12" y2="55" stroke="#000" strokeWidth="3" />
            <line x1="20" y1="45" x2="28" y2="55" stroke="#000" strokeWidth="3" />
          </svg>
          <div style={{ backgroundColor: 'white', border: '2px solid #333', borderRadius: '8px', padding: '6px 10px', fontSize: '15px', position: 'relative' }}>
            Think about how<br />you did in this<br />project.
            <div style={{ position: 'absolute', left: '-10px', top: '50%', transform: 'translateY(-50%)', width: 0, height: 0, borderStyle: 'solid', borderWidth: '5px 10px 5px 0', borderColor: 'transparent white transparent transparent' }} />
          </div>
        </div>

        <div style={{ backgroundColor: '#4A90A4', color: 'white', padding: '8px', fontWeight: 'bold', fontSize: '15px', textAlign: 'center', marginBottom: '10px' }}>
          Learner Reflection
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
          {reflectionPrompts.slice(0, 6).map((prompt, idx) => (
            <div key={prompt.key} style={{ position: 'relative' }}>
              <div style={{ border: '1px solid #4A90A4' }}>
                <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px', padding: '8px 8px 4px 8px' }}>
                  {prompt.label}
                </div>
                <textarea
                  value={formData[prompt.key] || ''}
                  onChange={(e) => handleChange(prompt.key, e.target.value)}
                  onBlur={() => saveChanges(formData)}
                  style={{
                    width: '100%',
                    backgroundColor: '#B3D9E8',
                    border: 'none',
                    borderTop: '1px solid #4A90A4',
                    padding: '8px',
                    minHeight: '80px',
                    fontSize: '14px',
                    fontFamily: "'Poppins', Arial, sans-serif",
                    resize: 'vertical',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              {idx < 5 && (
                <div style={{ position: 'absolute', [idx % 2 === 0 ? 'right' : 'left']: '-15px', bottom: '-10px', fontSize: '24px', color: '#333' }}>
                  {idx % 2 === 0 ? '→' : '←'}
                </div>
              )}
            </div>
          ))}
          <div style={{ gridColumn: '1 / -1' }}>
            <div style={{ border: '1px solid #4A90A4' }}>
              <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '4px', padding: '8px 8px 4px 8px' }}>
                {reflectionPrompts[6].label}
              </div>
              <textarea
                value={formData[reflectionPrompts[6].key] || ''}
                onChange={(e) => handleChange(reflectionPrompts[6].key, e.target.value)}
                onBlur={() => saveChanges(formData)}
                style={{
                  width: '100%',
                  backgroundColor: '#B3D9E8',
                  border: 'none',
                  borderTop: '1px solid #4A90A4',
                  padding: '8px',
                  minHeight: '60px',
                  fontSize: '14px',
                  fontFamily: "'Poppins', Arial, sans-serif",
                  resize: 'vertical',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Corners */}

    </div>
  );
};

export default PartBPage8;
